module.exports = __webpack_public_path__ + "img/avatar2.64f7bca7.png";